import { render } from "./TextItemElement.vue?vue&type=template&id=dc4e3c48&ts=true"
import script from "./TextItemElement.vue?vue&type=script&lang=ts"
export * from "./TextItemElement.vue?vue&type=script&lang=ts"

import "./TextItemElement.vue?vue&type=style&index=0&id=dc4e3c48&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QPopupEdit,QInput,QBtn,QTooltip});
